import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../styles/messages.css";

interface Message {
  id: string;
  fromUserId: string;
  toUserId: string;
  content: string;
  createdAt: string;
}

interface ChatBoxProps {
  chatId: string;
  reloadTrigger?: number;
  myUserId: string;
}

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

const ChatBox: React.FC<ChatBoxProps> = ({
  chatId,
  reloadTrigger,
  myUserId,
}) => {
  const [messages, setMessages] = useState<Message[]>([]);
  const [offset, setOffset] = useState<number>(0);
  const [hasMore, setHasMore] = useState<boolean>(true);
  const token = localStorage.getItem("token");
  const limit = 5;

  const fetchMessages = async (currentOffset: number) => {
    try {
      const response = await axios.get(
        `${SERVER_URL}/api/message/chats/${chatId}/messages?limit=${limit}&offset=${currentOffset}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // API returns an array of messages sorted descending (newest first)
      const fetchedMessages: Message[] = response.data || [];
      if (fetchedMessages.length < limit) {
        setHasMore(false);
      }
      if (currentOffset === 0) {
        // For initial load, reverse messages to show oldest at the top and newest at the bottom
        setMessages([...fetchedMessages].reverse());
      } else {
        // For loading older messages, prepend them so that new messages remain at the bottom
        setMessages((prev) => [...[...fetchedMessages].reverse(), ...prev]);
      }
      setOffset(currentOffset + fetchedMessages.length);
    } catch (error) {
      console.error("Error fetching messages:", error);
    }
  };

  useEffect(() => {
    if (chatId) {
      setMessages([]);
      setOffset(0);
      setHasMore(true);
      fetchMessages(0);
    }
  }, [chatId, reloadTrigger]);

  return (
    <div className="chat-box">
      {hasMore && (
        <button
          className="load-more-button"
          onClick={() => fetchMessages(offset)}
        >
          Load More
        </button>
      )}
      <div className="message-list">
        {messages.map((msg) => {
          const isSent = msg.fromUserId === myUserId;
          return (
            <>
              <div
                key={msg.id}
                className={isSent ? "message-sent" : "message-received"}
              >
                <p className="message-content">{msg.content}</p>
              </div>
              <small>{new Date(msg.createdAt).toLocaleTimeString()}</small>
            </>
          );
        })}
      </div>
    </div>
  );
};

export default ChatBox;
